module.exports = __webpack_public_path__ + "assets/media/chat-bot.a08ab4e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookTargetingStep/chat-bot.svg
// module id = 2993
// module chunks = 0